"use strict";

angular.module("core")
.component("paymentPrintButton", {
    controllerAs: "paymentPrintButtonCtrl",
    templateUrl: require("./payment-print-button.component.html"),
    bindings: {
        paymentId: "<",
        service: "<",
        defaultPrintFormat: "<?"
    },
    controller: function(
        $scope, IS_MOBILE, IS_MOBILE_APP, ZebraPrinterService, PaymentPrintButtonService
    ) {
        $scope.isMobile = IS_MOBILE;
        $scope.isMobileApp = IS_MOBILE_APP;
        $scope.isZebraPrinterSupported = ZebraPrinterService.isSupported();
        $scope.hasFavouritePrinter = ZebraPrinterService.hasFavouritePrinter;

        this.$onInit = function() {
            if (this.defaultPrintFormat === undefined) {
                this.defaultPrintFormat = PaymentPrintButtonService.PDF_RECEIPT_FORMAT;
            }
        }

        this.downloadDefaultFormatPDF = function() {
            $scope.isPrintButtonDisabled = true;
            PaymentPrintButtonService.downloadPaymentPDF(
                this.paymentId,
                this.defaultPrintFormat,
                this.service
            ).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.downloadReceiptPDF = function() {
            $scope.isPrintButtonDisabled = true;
            PaymentPrintButtonService.downloadPaymentPDF(
                this.paymentId,
                PaymentPrintButtonService.PDF_RECEIPT_FORMAT,
                this.service
            ).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }

        this.printReceiptPDF = function(forceSelectPrinter) {
            $scope.isPrintButtonDisabled = true;
            PaymentPrintButtonService.printReceiptPDF(
                this.paymentId,
                this.service,
                forceSelectPrinter
            ).then(function onSuccess() {
                $scope.hasFavouritePrinter = true;
            }).finally(function() {
                $scope.isPrintButtonDisabled = false;
            });
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-print-button/payment-print-button.component.js
// module id = 530
// module chunks = 0